import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withStyles, CircularProgress } from '@material-ui/core'
import DudeReadingV2Icon from 'components/theme/DudeReadingV2Icon'
import Ellipsis from 'components/VastGPT/Ellipsis'
// import TypeAnimation from 'components/theme/TypeAnimation'

const styles = theme => ({})

const loadingText = 'Generating an AI response...'

class OpenAI extends Component {
  render() {
    return (
      <div style={{ textAlign: 'center', padding: 20 }}>
        <DudeReadingV2Icon
          style={{ width: 75, height: 75, color: '#014c94' }}
        />
        <div style={{ marginTop: 10, textAlign: 'left', fontSize: 25 }}>
          {this.props.loading === 'initial' ||
          this.props.loading === 'loading' ? (
            <>
              {loadingText}
              <CircularProgress
                style={{
                  width: 30,
                  height: 30,
                  verticalAlign: 'bottom',
                  marginLeft: 13,
                }}
              />
            </>
          ) : this.props.content ? (
            <>
              {this.props.content}
              {this.props.loading === 'loadingWithText' ? <Ellipsis /> : null}
            </>
          ) : (
            <>
              AI is trying to load. Please give us a moment, as we're still
              fine-tuning this component for a smoother experience. We
              appreciate your patience as we continue to improve its performance
              and ensure a reliable service. This feature is in beta and may
              cause issues. You may try again later if it appears to not be
              working.
              <CircularProgress
                style={{
                  width: 30,
                  height: 30,
                  verticalAlign: 'bottom',
                  marginLeft: 13,
                }}
              />
            </>
          )}
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    loading: state.InboxAI.loadingInboxResponse,
    content:
      Object.values(state.data?.openaiinboxresponse || {})?.[0]?.message
        ?.content || '',
  }),
  null,
)(withStyles(styles)(OpenAI))
